import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { SmoothLink } from '@bd/bdcore-utilities';
// import { Link } from '@bd/bdcore-named-routes';
import ContactModal from '../../components/ContactModal';
import ContactBannerDetail from '../../components/ContactBannerDetail';

const styles = css`
`;

function Overview({ community, homes, plans, agents }) {
  return (
    <div className={styles}>
      <div className="DetailSection">
        <div className="ScrollTarget" id="overview" />
        <div className="DetailOverview">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="DetailOverview_headingWrapper">
                  <h2 className="DetailOverview_heading">
                    {get(community, 'name')}
                    <span className="DetailOverview_subheading">{get(community, 'address.streetAddress')} | {get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')} {get(community, 'address.postalCode')}</span>
                  </h2>
                  <div className="DetailOverview_mapButton">
                    <SmoothLink href="#map">
                      <img src="/images/icon-map-pin.svg" alt="" />
                    </SmoothLink>
                  </div>
                </div>
                <div className="DetailOverview_sectionWrapper">
                  {
                    get(community, 'priceLow') &&
                    get(community, 'priceHigh') &&
                    <div className="DetailOverview_price">
                      <span className="DetailOverview_priceLabel">Price Range</span>
                      <span>${numeral(get(community, 'priceLow')).format('0,0')} - ${numeral(get(community, 'priceHigh')).format('0,0')}</span>
                    </div>
                  }
                  {
                    get(community, 'priceLow') &&
                    !get(community, 'priceHigh') &&
                    <div className="DetailOverview_price">
                      <span className="DetailOverview_priceLabel">Priced From</span>
                      <span>${numeral(get(community, 'priceLow')).format('0,0')}</span>
                    </div>
                  }
                </div>
                {
                  (plans.length > 0 || homes.length > 0) &&
                  <div className="DetailOverview_sectionWrapper">
                    {
                      plans.length > 0 &&
                      <span className="DetailOverview_sectionItem DetailOverview_sectionItem-count">
                        <SmoothLink href="#plans">Floor Plans <span className="badge">{plans.length}</span></SmoothLink>
                      </span>
                    }
                    {
                      homes.length > 0 &&
                      <span className="DetailOverview_sectionItem DetailOverview_sectionItem-count">
                        <SmoothLink href="#homes">Quick Move-In Homes <span className="badge">{homes.length}</span></SmoothLink>
                      </span>
                    }
                  </div>
                }
                {
                  get(community, 'hours') &&
                  <div className="DetailOverview_sectionWrapper">
                    {
                      <div>
                        <strong>Hours: </strong>{get(community, 'hours')}
                      </div>
                    }
                  </div>
                }
                <div className="d-lg-none mb-1">
                  <ContactModal>
                    <span className="btn btn-brand3 w-100">Schedule A Visit</span>
                  </ContactModal>
                </div>
              </div>
              <div className="col-lg-6 d-none d-lg-block">
                <ContactBannerDetail product="community" agents={agents} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Overview.propTypes = {
  community: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object),
  plans: PropTypes.arrayOf(PropTypes.object),
  agents: PropTypes.arrayOf(PropTypes.object),
};

Overview.defaultProps = {
  homes: [],
  plans: [],
  agents: [],
};

export default withData(
  {
    community: true,
    homes: true,
    plans: true,
  },
  {
    required: {
      community: true,
    },
  },
)(Overview);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/Overview.js